<script>
import Icon from '~/components/icon';
import PasswordCheck from './password_check';

import { containsSpecialCharacter } from '~/lib/utils/text';

export default {
  components: {
    Icon,
    PasswordCheck
  },

  props: {
    id: {
      type: String,
      required: true
    },

    name: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      inputType: 'password',
      iconName: 'eye',
      password: null,
      title: this.t('user_backend.js.sign_up.show_password')
    };
  },

  computed: {
    hasEnoughCharacters() {
      return this.password !== null && this.password.length >= 8;
    },

    containsSpecialCharacter() {
      return containsSpecialCharacter(this.password);
    },

    containsCapitalLetter() {
      return /[A-Z]/.test(this.password);
    },

    containsNumber() {
      return /\d/.test(this.password);
    }
  },

  methods: {
    toggleInput() {
      if (this.inputType === 'password') {
        this.inputType = 'text';
        this.iconName = 'eye-off';
        this.title = this.t('user_backend.js.sign_up.hide_password');
      } else {
        this.inputType = 'password';
        this.iconName = 'eye';
        this.title = this.t('user_backend.js.sign_up.show_password');
      }

      this.$refs.input.focus();
    }
  }
};
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <label :for="id">
        {{ label }}
      </label>

      <button
        class="c-button c-button--link"
        :title="title"
        @click.prevent="toggleInput"
      >
        <icon
          :name="iconName"
          size="header"
        />
      </button>
    </div>

    <input
      :id="id"
      ref="input"
      v-model="password"
      class="no-mouseflow"
      :name="name"
      :type="inputType"
    >

    <div class="mt-3">
      <password-check
        :text="t('user_backend.js.sign_up.minimum_eight_characters')"
        :check="hasEnoughCharacters"
      />

      <password-check
        :text="t('user_backend.js.sign_up.one_capital_letter')"
        :check="containsCapitalLetter"
      />

      <password-check
        :text="t('user_backend.js.sign_up.one_number')"
        :check="containsNumber"
      />

      <password-check
        :text="t('user_backend.js.sign_up.one_special_character')"
        :check="containsSpecialCharacter"
      />
    </div>
  </div>
</template>
